import axios from '@/plugins/axios';
import utils from '@/stores/utils';
import synchronize from './submodules/synchronize';
import store from '@/stores/store';


const state = {
    provider: null,
    producttypes: [],
    producttypes_loading: false,
    producttypes_loaded: false,
    producttypes_loading_errors: null,
};


const mutations = {
    updateProductTypes(state, producttypes) {
        state.producttypes = producttypes;
        state.producttypes_loaded = true;
        state.producttypes_loading = false;
    },
    updateProductTypesLoading(state, loading) {
        state.producttypes_loading = loading;
        if (loading) {
            state.producttypes_loading_errors = null;
            state.producttypes_loaded = false;
        }
    },
    updateProductTypesLoadingErrors(state, errors) {
        state.producttypes_loading_errors = errors;
        state.producttypes_loading = false;
        state.producttypes_loaded = true;
    },
    updateProvider(state, provider) {
        state.provider = provider;
    },
};

const actions = {
    
    async init({ commit, dispatch, state }, params) {
        const providerId = normalizeProviderId(params.provider);
        await dispatch("synchronize/init", { extra_params: { provider: providerId } });
        await dispatch("fetchProductTypes");
    },

    changeProvider({ commit, dispatch, state }, provider) {
        const providerId = normalizeProviderId(provider);
        commit("updateProvider", provider);
        commit("synchronize/updateExtraParams", { provider: providerId });
    },


    async fetchProductTypes({ commit, dispatch, state }, params) {
        commit('updateProductTypesLoading', true);

        try {
            const response = await axios.get('/api/producttypes/', { params: { limit: 500 } });
            commit('updateProductTypes', response.data.results);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateProductTypesLoadingErrors', error.details);
            throw error;
        }
    },
};


function normalizeProviderId(provider) {
    if (provider == null) {
        return null;
    }
    if (typeof provider === "object") {
        return provider.id ?? null;
    }
    return provider;
}

export default {
    namespaced: true,
    state,

    actions,
    mutations,
    modules: {
        synchronize: synchronize(),
    }
};
